import { render } from "./AdminEstateInteriorColours.vue?vue&type=template&id=8c09262a&scoped=true&ts=true&lang=pug"
import script from "./AdminEstateInteriorColours.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminEstateInteriorColours.vue?vue&type=script&lang=ts&setup=true"

import "./AdminEstateInteriorColours.vue?vue&type=style&index=0&id=8c09262a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c09262a"]])

export default __exports__